"use client";

import { createContext, useContext } from "react";
import { GetPinnedItems, UpdatePinnedItems } from "../actions";

interface SidebarContextType {
    getPinnedItems: GetPinnedItems;
    updatePinnedItems: UpdatePinnedItems;
    isMatchMakerSubRoute?: boolean;
}

interface SidebarProviderProps extends SidebarContextType {
    children: React.ReactNode;
    isMatchMakerSubRoute?: boolean;
}

const SidebarItemsContext = createContext<SidebarContextType | undefined>(
    undefined,
);

export const SidebarItemsProvider = ({
    getPinnedItems,
    updatePinnedItems,
    children,
    isMatchMakerSubRoute = false,
}: SidebarProviderProps) => {
    return (
        <SidebarItemsContext.Provider
            value={{
                getPinnedItems,
                updatePinnedItems,
                isMatchMakerSubRoute,
            }}
        >
            {children}
        </SidebarItemsContext.Provider>
    );
};

export const usePinnedSideBarItems = () => {
    const context = useContext(SidebarItemsContext);

    if (!context) {
        throw new Error(
            "usePinnedSideBarItems must be used within a SidebarItemsProvider",
        );
    }

    return context;
};
